import React, { useState } from 'react'
import Box from '@mui/material/Box'
import Modal from '@mui/material/Modal'
import { useModalContext } from '../../../contexts/ModalContext'
import TextField from '@mui/material/TextField'
import { Container, FormContainer } from './styles'
import * as PromotionService from '../../../services/promotions'
import Button from '@mui/material/Button'
import { ImageList, ImageListItem, Typography, Switch, FormControlLabel, Divider } from '@mui/material'
import { ZoomIn, Link } from '@mui/icons-material'

function formatDate(dateStr) {
    if (!dateStr) return '—'
    return new Date(dateStr).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    })
}

const ManagePromotionModal = ({ updateTable, mechanicPromotion }) => {
    const { setModal } = useModalContext('')
    const [reason, setReason] = useState(mechanicPromotion.reason ?? '')
    const [images, setImages] = useState(mechanicPromotion.images || [])

    const handleClose = () => setModal(null)

    const handleUrlChange = (index, newUrl) => {
        const newImages = [...images]
        newImages[index] = { ...newImages[index], url: newUrl }
        setImages(newImages)
    }

    const handleExternalUrlChange = (index) => {
        const newImages = [...images]
        newImages[index] = {
            ...newImages[index],
            isExternalUrl: !newImages[index].isExternalUrl
        }
        setImages(newImages)
    }

    const approve = async (event) => {
        event.preventDefault()

        const body = {
            mechanicId: mechanicPromotion.mechanicId,
            images: images
        }

        await PromotionService.approve(body)
            .then(() => {
                alert('Promoção aprovada!')
                setModal(null)
                updateTable()
            })
            .catch(() => alert('Erro aprovar esta promoção!'))
    }

    const deny = async (event) => {
        event.preventDefault()

        const body = {
            mechanicId: mechanicPromotion.mechanicId,
            reason: reason,
            images: images
        }

        await PromotionService.deny(body)
            .then(() => {
                alert('Promoção negada!')
                setModal(null)
                updateTable()
            })
            .catch(() => alert('Erro negar esta promoção!'))
    }

    return (
        <>
            <Modal
                open={true}
                onClose={handleClose}
                aria-labelledby='modal-modal-title'
                aria-describedby='modal-modal-description'
            >
                <Container>
                    <Box
                        m={3}
                        fontWeight='bold'
                        color='#666666'
                        fontSize={{
                            xs: 'h7.fontSize',
                            sm: 'h7.fontSize',
                            md: 'h6.fontSize',
                            xl: 'h5.fontSize'
                        }}
                    >
                        Gerenciar Promoção
                    </Box>
                    <FormContainer>
                        <Typography>
                            <b>Mecânica:</b> {mechanicPromotion.mechanicName}
                        </Typography>
                        <Box
                            sx={{
                                background: '#f5f5f5',
                                borderRadius: 1,
                                p: 1.5,
                                mt: 1,
                                mb: 1
                            }}
                        >
                            <Typography variant='body2'>
                                <b>Início:</b> {formatDate(mechanicPromotion.startDate)}
                            </Typography>
                            <Typography variant='body2'>
                                <b>Fim:</b> {formatDate(mechanicPromotion.endDate)}
                            </Typography>
                        </Box>
                        <Divider sx={{ mb: 1 }} />
                        {images.length > 0 && (
                            <>
                                <Typography fontSize={16} marginTop={1}>
                                    <b>Imagens</b>
                                </Typography>
                                <ImageList sx={{ height: 350, maxWidth: 1100 }} cols={3} rowHeight={164}>
                                    {images.map((item, index) => (
                                        <ImageListItem key={index}>
                                            <img
                                                srcSet={`${item.imageUrl}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                                                src={`${item.imageUrl}?w=164&h=164&fit=crop&auto=format`}
                                                alt='Upload preview'
                                                loading='lazy'
                                            />
                                            <Box sx={{ mt: 1, mb: 1 }}>
                                                <Button
                                                    href={item.imageUrl}
                                                    target='_blank'
                                                    rel='noopener noreferrer'
                                                    startIcon={<ZoomIn />}
                                                    sx={{ mb: 1 }}
                                                >
                                                    Ampliar
                                                </Button>
                                                <TextField
                                                    fullWidth
                                                    size='small'
                                                    label='URL'
                                                    value={item.url}
                                                    onChange={(e) => handleUrlChange(index, e.target.value)}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <Button
                                                                href={item.url}
                                                                target='_blank'
                                                                rel='noopener noreferrer'
                                                                startIcon={<Link />}
                                                            >
                                                                Abrir
                                                            </Button>
                                                        )
                                                    }}
                                                />
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={item.isExternalUrl}
                                                            onChange={() => handleExternalUrlChange(index)}
                                                        />
                                                    }
                                                    label='URL Externa?'
                                                />
                                            </Box>
                                        </ImageListItem>
                                    ))}
                                </ImageList>
                            </>
                        )}
                        <TextField
                            name='reason'
                            label='Motivo'
                            value={reason}
                            variant='outlined'
                            style={{ width: '100%' }}
                            onChange={(event) => setReason(event.target.value)}
                            multiline
                            rows={4}
                            required
                        />
                    </FormContainer>
                    <Box display='flex' justifyContent='flex-end' padding='20px' justifySelf='center'>
                        <Button
                            variant='contained'
                            style={{
                                marginRight: '4px',
                                background: 'green',
                                color: 'white'
                            }}
                            onClick={(event) => approve(event)}
                        >
                            Aprovar
                        </Button>
                        <Button
                            variant='contained'
                            style={{
                                marginRight: '4px',
                                background: 'red',
                                color: 'white'
                            }}
                            onClick={(event) => deny(event)}
                        >
                            Negar
                        </Button>
                        <Button variant='outlined' onClick={() => handleClose()}>
                            Fechar
                        </Button>
                    </Box>
                </Container>
            </Modal>
        </>
    )
}

export default ManagePromotionModal
